var React = require('react');

function IconConnectedForms (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.04 2h-9.8c-1.084 0-1.96.894-1.96 2v4c0 1.106.876 2 1.96 2h23.116a.974.974 0 0 0 .692-.294l2.94-3c.38-.387.38-1.025 0-1.412l-2.94-3A.974.974 0 0 0 27.356 2H17.96c0-1.106-.876-2-1.96-2s-1.96.894-1.96 2Zm15.68 14c0-1.106-.876-2-1.96-2h-9.8v-2h-3.92v2H4.644a.974.974 0 0 0-.692.294l-2.94 3a1.018 1.018 0 0 0 0 1.412l2.94 3a.974.974 0 0 0 .692.294H27.76c1.084 0 1.96-.894 1.96-2v-4ZM17.96 30v-6h-3.92v6c0 1.106.876 2 1.96 2s1.96-.894 1.96-2Z","fill":"currentColor"}));
}

IconConnectedForms.defaultProps = {"fill":"currentColor","viewBox":"0 0 32 32"};

module.exports = IconConnectedForms;

IconConnectedForms.default = IconConnectedForms;
